import { Button, Col, Row } from '@/components';
import { t } from '@/i18n';
import type { FC } from 'react';
import { useLocation, useNavigate } from 'react-router';
import type { z } from 'zod';
import type { masterPathType } from '../models/master';

type Path = Array<{ label: string; path: z.infer<typeof masterPathType> }>;

const pathsForRs: Path = [
  { label: t('policy'), path: 'policy' },
  { label: t('accounting-type'), path: 'accounting-type' },
  { label: t('account-title'), path: 'account-title' },
  { label: t('budget-type'), path: 'budget-type' },
  { label: t('expenditure-purpose'), path: 'expenditure-purpose' },
  { label: t('major-matter'), path: 'major-matter' },
  {
    label: t('expenditure-budget-jurisdiction'),
    path: 'expenditure-budget-jurisdiction',
  },
  {
    label: t('expenditure-budget-organization'),
    path: 'expenditure-budget-organization',
  },
  {
    label: t('expenditure-budget-purpose'),
    path: 'expenditure-budget-purpose',
  },
  {
    label: t('expenditure-item-major-matter'),
    path: 'expenditure-item-major-matter',
  },
  { label: t('cost'), path: 'cost' },
  { label: t('ministry'), path: 'ministry' },
];

export const MasterTableListPage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Row gutter={[16, 16]}>
      {pathsForRs.map((d) => (
        <Col key={d.path} span={6}>
          <Button
            style={{ width: 160 }}
            onClick={() => {
              navigate(`${location.pathname}/${d.path}`);
            }}
          >
            {d.label}
          </Button>
          <div />
        </Col>
      ))}
    </Row>
  );
};
